<script>
import {Line} from "vue-chartjs";

export default {
  name: "Chart",
  extends: Line,
  props: {
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    datasets: [], labels: [], chartoptions: null},
  data() {
    return {
      chartData: {
        "labels": this.labels,
        "datasets": this.datasets
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartoptions);
  }
};
</script>
